<template>
	<div class="table">
		<el-table
			border
			ref="multipleTable"
			id="exportTab"
			:data="tableData"
			:header-cell-style="{ 'text-align': 'center' }"
			height="60vh"
			:cell-style="{ 'text-align': 'center' }"
			tooltip-effect="dark"
			style="width: 100%"
		>
			<el-table-column prop="date" label="日期" width="120px">
			</el-table-column>
			<el-table-column prop="total_ai_ratio" label="人工原创">
				<template slot-scope="scope">
					<span>
						{{ scope.row.rgycCount }}
					</span>
				</template>
			</el-table-column>
			<el-table-column prop="total_ai_ratio" label="AI原创">
				<template slot-scope="scope">
					<span>
						{{ scope.row.aiycEditCount }}
					</span>
				</template>
			</el-table-column>
			<el-table-column prop="flash_ai_ratio" label="AI转载">
				<template slot-scope="scope">
					<span>
						{{ scope.row.spiderReCount }}
					</span>
				</template>
			</el-table-column>
			<el-table-column prop="column_ai_ratio" label="人工转载">
				<template slot-scope="scope">
					<span>
						{{ scope.row.rgReCount }}
					</span>
				</template>
			</el-table-column>
			<el-table-column prop="manual_ai_ratio" label="PR稿">
				<template slot-scope="scope">
					<span>
						{{ scope.row.PRCount }}
					</span>
				</template>
			</el-table-column>
			<el-table-column prop="manual_ai_ratio" label="专栏文章">
				<template slot-scope="scope">
					<span>
						{{ scope.row.columnCount }}
					</span>
				</template>
			</el-table-column>
			<el-table-column prop="news_ai_ratio" label="AIMPACT">
				<template slot-scope="scope">
					<span>
						{{ scope.row.aiycCount }}
					</span>
				</template>
			</el-table-column>
			<el-table-column prop="manual_ai_ratio" label="总量">
				<template slot-scope="scope">
					<span>
						{{ scope.row.totalCount }}
					</span>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
import { disInformation, delInformation, informationHome } from "@/api/article";
export default {
	props: ["tableData"],
	name: "",
	data() {
		return {
			value: true,
		};
	},
	methods: {
		showPreView(row) {
			let url = "https://me.news/contents/" + row.id;
			if (row.type == 2) {
				url = "https://me.news/news/" + row.id;
			}
			window.open(url, "预览");
		},

		detailView(row) {
			this.$router.push({
				path: "/webdata/singleList",
				query: { id: row.id },
			});
		},
	},
};
</script>

<style scoped></style>
